import React from 'react';
import { CircularIndicator, Divider } from 'src/components/atoms';
import { CircularIndicatorState } from 'src/components/atoms/CircularIndicator/CircularIndicator.styles';
import {
  ActiveLabel,
  StepperContainer,
  StepperSpacer,
  StepperStep,
} from './Stepper.styles';

export interface StepperProps {
  /**
   * Which step is the user currently on?
   */
  activeStep: number;
  /**
   * List of step labels (in expected order).
   */
  steps: Array<string>;
}

/**
 * These steppers are used in the CSV Upload flow.
 */
export const Stepper: React.FC<StepperProps> = ({
  activeStep = 0,
  steps = [],
}: StepperProps) => {
  return (
    <StepperContainer data-testid="stepper-container">
      {steps.map((label, index) => {
        let state: CircularIndicatorState = 'unvisited';
        if (activeStep === index) {
          state = 'current step';
        }
        const completed = activeStep > index;
        if (completed) {
          state = 'complete';
        }
        const variant = completed ? 'icon' : 'text';
        const showDivider = index !== steps.length - 1;
        return (
          <StepperStep key={label + index}>
            <CircularIndicator
              state={state}
              step={index + 1}
              variant={variant}
              data-testid={`step-indicator-${label}`}
              data-state={state}
            />
            <StepperSpacer />
            <ActiveLabel data-testid={`step-${label}`}>{label}</ActiveLabel>
            <StepperSpacer />
            {showDivider && <Divider variant={'horizontal'} width={'60px'} />}
            {showDivider && <StepperSpacer />}
          </StepperStep>
        );
      })}
    </StepperContainer>
  );
};
